import { Link } from "react-router-dom";
import { FacebookLogo, InstagramLogo, MapPin, Phone, EnvelopeSimple } from "@phosphor-icons/react";
import { COMPANY, IMAGES } from "../data/site";
import { Blob } from "./Decor";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative overflow-hidden bg-[#14183A] text-white">
      <Blob color="blue" className="-left-24 -top-24" size={420} opacity={0.25} />
      <Blob color="orange" className="-bottom-32 right-0" size={380} opacity={0.18} />

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 py-16 md:grid-cols-3 md:px-12 md:py-20">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-white/95">
              <img src={IMAGES.logo} alt="Logo Lisse Energies" className="h-8 w-8 object-contain" />
            </span>
            <span className="text-xl font-extrabold tracking-tight">
              Lisse <span className="text-[#3CC0E7]">Energies</span>
            </span>
          </div>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
            {COMPANY.baseline}
          </p>
          <span className="mt-5 inline-flex items-center gap-2 rounded-full border border-[#FC8529]/50 bg-[#FC8529]/15 px-4 py-1.5 text-xs font-semibold">
            <span className="h-2 w-2 rounded-full bg-[#FC8529]" />
            Artisan RGE — éligible MaPrimeRénov' &amp; CEE
          </span>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Navigation</h4>
          <ul className="mt-5 space-y-3 text-sm">
            {[
              ["/", "Accueil"],
              ["/prestations", "Prestations"],
              ["/realisations", "Réalisations"],
              ["/a-propos", "À propos"],
              ["/contact", "Contact"],
            ].map(([to, label]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-link-${label.toLowerCase()}`}
                  className="text-white/70 transition-colors hover:text-[#3CC0E7]"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Contact</h4>
          <ul className="mt-5 space-y-4 text-sm text-white/70">
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-[#3CC0E7]" />
              <span>{COMPANY.address.full}<br />{COMPANY.address.department}</span>
            </li>
            <li>
              <a href={COMPANY.phoneLink} data-testid="footer-phone" className="flex items-center gap-3 hover:text-white">
                <Phone weight="fill" className="h-5 w-5 text-[#FF3123]" /> {COMPANY.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-white">
                <EnvelopeSimple className="h-5 w-5 text-[#3CC0E7]" /> {COMPANY.email}
              </a>
            </li>
          </ul>
          <div className="mt-6 flex gap-3">
            <a href={COMPANY.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/20 transition-all hover:border-[#3CC0E7] hover:text-[#3CC0E7]">
              <FacebookLogo weight="fill" className="h-5 w-5" />
            </a>
            <a href={COMPANY.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/20 transition-all hover:border-[#FF3123] hover:text-[#FF3123]">
              <InstagramLogo weight="fill" className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-3 px-6 py-6 text-xs text-white/50 md:flex-row md:items-center md:justify-between md:px-12">
          <p>
            © {new Date().getFullYear()} Lisse Energies — Tous droits réservés · N° RGE Qualit'EnR : {COMPANY.rgePlaceholder}
          </p>
          <div className="flex gap-5">
            <Link to="/mentions-legales" data-testid="footer-mentions" className="hover:text-white">Mentions légales</Link>
            <Link to="/confidentialite" data-testid="footer-confidentialite" className="hover:text-white">Politique de confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
